import { withStyles } from '@material-ui/core/styles';

import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

export const Accordion = withStyles((theme: any) => ({
  root: {
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.lighterSnowColor}`,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
}))(MuiAccordion);

export const AccordionSummary = withStyles((theme: any) => ({
  root: {
    padding: '1.5rem',
    '&$expanded': {
      borderBottom: `1px solid ${theme.lighterSnowColor}`,
    },
  },
  content: {
    margin: 0,
    fontSize: '0.9rem',
    fontWeight: 500,
    '&$expanded': {
      margin: 0,
    },
    '& > span:last-child': {
      marginLeft: 'auto',
    },
    '& > label': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    '& > label > span:first-child': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '0.5rem',
      width: '0.7rem',
      height: '0.7rem',
      borderRadius: '50%',
      border: `1px solid ${theme.gainsboroColor}`,
      backgroundColor: theme.whiteColor,
    },
    '& > label > span:first-child > span': {
      width: '0.4rem',
      height: '0.4rem',
      borderRadius: '50%',
      backgroundColor: theme.whiteColor,
    },
  },
  expanded: {
    '& > label > span:first-child > span': {
      backgroundColor: theme.darkGrayColor,
    },
  },
}))(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1.5rem',
    border: 'none',
    fontWeight: 500,
    color: theme.dimGrayColor,
    backgroundColor: theme.whiteSmokeColor,
  },
}))(MuiAccordionDetails);
